<template>
    <div>
        <base-header class="pb-1">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0"></h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <form @submit.prevent="findUser">
                <div class="col-md-12">
                    <card>
                        <h3 slot="header" class="mb-0">Usuários</h3>
                        <div class="row">
                            <div class="col-md-9">
                                <div class="form-group">
                                    <label>Filtro</label>
                                    <input type="text" class="form-control" v-model="name" placeholder="Nome"
                                        @keyup.enter="findUser" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <base-button type="primary" @click="findUser">Buscar</base-button>
                            </div>
                        </div>
                        <div class="col-md-12 text-right mb-3 pr-5">
                            <base-button type="neutral" icon size="sm" @click="newUser">
                                <span class="btn-inner--icon"><i class="fas fa-wallet"></i></span>
                                <span class="btn-inner--text">Novo Usuário</span>
                            </base-button>
                        </div>
                        <table class="table font-tabela-peq">
                            <thead class="thead">
                                <tr>
                                    <th scope="col">Nome</th>
                                    <th scope="col">Login</th>
                                    <th scope="col">Perfil</th>
                                    <th scope="col">Ativo?</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in users" :key="user.id">
                                    <td><a href="javascript:void(0);" @click.prevent="open(user.id)">{{ user.name }}</a>
                                    </td>
                                    <td class="text-center">{{ user.login }}</td>
                                    <td class="text-center">
                                        <span v-if="user.profile == 'DEPENDENT'">Dependente</span>
                                        <span v-if="user.profile == 'HOLDER'">Titular</span>
                                        <span v-if="user.profile == 'ATTENDANT'">Atendente</span>
                                        <span v-if="user.profile == 'MANAGER'">Gerente</span>
                                        <span v-if="user.profile == 'SUPERVISOR'">Supervisor</span>
                                        <span v-if="user.profile == 'ADMIN'">Administrador</span>
                                        <span v-if="user.profile == 'BROKER'">Corretor</span>
                                    </td>
                                    <td class="text-center">
                                        <span>{{ user.active ? "Sim" : "Não" }}</span>
                                    </td>
                                    <td>
                                        <a href="#" title="Alterar Usuário" @click.prevent="open(user.id)"><i
                                                class="far fa-folder-open"></i></a>
                                        <a v-if="isAdmin" href="#" title="Enviar senha temporária por e-mail"
                                            @click.prevent="sendTemporaryPassword(user)" class="ml-2"><i
                                                class="fas fa-key"></i></a>
                                        <a v-if="isAdmin" href="#" title="Resetar MFA / celular"
                                            @click.prevent="openMfaReset(user)" class="ml-2"><i
                                                class="fas fa-mobile-alt"></i></a>
                                    </td>
                                </tr>
                                <tr v-show="users.length == 0">
                                    <td colspan="8">
                                        <center>Nenhum usuário disponível.</center>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </card>
                </div>
            </form>
        </div>

        <modal :show.sync="mfaModal.show">
            <template slot="header">
                <h5 class="modal-title">Resetar MFA / celular</h5>
            </template>
            <div>
                <p class="mb-3">
                    Usuário: <strong>{{ mfaModal.userName }}</strong>
                </p>
                <div class="form-group">
                    <label>Novo celular (opcional)</label>
                    <input type="text" class="form-control" v-model="mfaModal.phone"
                        v-mask="['(##) #####-####']" placeholder="Deixe em branco para não alterar" />
                    <small class="form-text text-muted">
                        Se informado, substitui o celular e fica não confirmado.
                    </small>
                </div>
                <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="clearMfa" v-model="mfaModal.clearMfa">
                    <label class="custom-control-label" for="clearMfa">Limpar MFA confirmado</label>
                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="mfaModal.show = false">Cancelar</base-button>
                <base-button type="primary" @click="confirmMfaReset" :disabled="loading">Confirmar</base-button>
            </template>
        </modal>
    </div>
</template>

<script>
export default {
  mounted() {
    this.findUser();
  },
  data() {
    return {
      name: '',
      users: [],
      loading: false,
      mfaModal: {
        show: false,
        userId: null,
        userName: '',
        phone: '',
        clearMfa: true
      }
    };
  },
  computed: {
    isAdmin() {
      return localStorage.getItem('profile') === 'ADMIN';
    }
  },
  methods: {
    getProfile() {
      return localStorage.getItem('profile');
    },
    newUser() {
      location.href = '/configuracoes/usuario/novo';
    },
    open(id) {
      location.href = '/configuracoes/usuario/editar/' + id;
    },
    sendTemporaryPassword(user) {
      const options = { title: 'Senha temporária', okLabel: 'Enviar', cancelLabel: 'Cancelar' };
      this.$dialogs.confirm(
        `Enviar senha temporária por e-mail para ${user.name}?`,
        options
      ).then((res) => {
        if (!res.ok) return;
        this.loading = true;
        this.$clubApi.post('/user/backoffice/password/temporary', {
          userId: user.id
        }).then((response) => {
          const msg = (response.data && response.data.object)
            || 'Senha temporária enviada por e-mail.';
          this.$notify({ type: 'success', message: msg });
        }).catch((error) => {
          this.$notify({
            type: 'warning',
            message: (error.response && error.response.data && error.response.data.msg)
              || 'Erro ao enviar senha temporária'
          });
        }).finally(() => {
          this.loading = false;
          NProgress.done();
        });
      });
    },
    openMfaReset(user) {
      this.mfaModal = {
        show: true,
        userId: user.id,
        userName: user.name,
        phone: '',
        clearMfa: true
      };
    },
    confirmMfaReset() {
      if (!this.mfaModal.clearMfa && !(this.mfaModal.phone || '').replace(/\D/g, '')) {
        this.$notify({
          type: 'warning',
          message: 'Informe um novo celular ou marque a opção de limpar MFA.'
        });
        return;
      }

      this.loading = true;
      const payload = {
        userId: this.mfaModal.userId,
        clearMfa: this.mfaModal.clearMfa
      };
      const phone = (this.mfaModal.phone || '').replace(/\D/g, '');
      if (phone) {
        payload.phone = phone;
      }

      this.$clubApi.post('/user/backoffice/mfa/reset', payload)
        .then(() => {
          this.$notify({ type: 'success', message: 'MFA/celular atualizado com sucesso.' });
          this.mfaModal.show = false;
        })
        .catch((error) => {
          this.$notify({
            type: 'warning',
            message: (error.response && error.response.data && error.response.data.msg)
              || 'Erro ao resetar MFA'
          });
        })
        .finally(() => {
          this.loading = false;
          NProgress.done();
        });
    },
    findUser() {
      const name = (this.name || '').trim();
      const url = name
        ? '/user/find/' + encodeURIComponent(name)
        : '/user/list/all';

      this.$clubApi.get(url)
        .then((response) => {
          this.users = response.data.object;
        }).catch((error) => {
          this.$notify({
            type: 'warning',
            message: (error.response && error.response.data && error.response.data.msg)
              || 'Erro ao buscar usuários'
          });
        }).finally(() => {
          NProgress.done();
        });
    }
  }
};
</script>

<style></style>
